/* eslint-disable */
export default {
  _background: 'background',
  _art_area: 'art_area',
  _drawing_area: 'drawing_area',
  _horizontal_line: 'horizontal_line',
  _color_dialog: 'color_dialog',
  _vertical_line: 'vertical_line',
  _c4: 'c4',
  _button1: 'button1',
  _button5: 'button5',
  _button6: 'button6',
  _mirror_horizontal_buttonb: 'mirror_horizontal_buttonb',
  _mirror_vertical_buttonb: 'mirror_vertical_buttonb',
  _button8b: 'button8b',
  _button8: 'button8',
  _button3: 'button3',
  _button4: 'button4',
  _button7: 'button7',
  _brush_large_buttonb: 'brush_large_buttonb',
  _button5b: 'button5b',
  _brush_large_button: 'brush_large_button',
  _brush_medium_buttonb: 'brush_medium_buttonb',
  _brush_small_buttonb: 'brush_small_buttonb',
  _button1b: 'button1b',
  _button6b: 'button6b',
  _button3b: 'button3b',
  _brush_medium_button: 'brush_medium_button',
  _button4b: 'button4b',
  _mirror_both_buttonb: 'mirror_both_buttonb',
  _c5: 'c5',
  _brush_small_button: 'brush_small_button',
  _c7: 'c7',
  _c8: 'c8',
  _c16: 'c16',
  _cancel_button: 'cancel_button',
  _mirror_both_button: 'mirror_both_button',
  _mirror_horizontal_button: 'mirror_horizontal_button',
  _mirror_vertical_button: 'mirror_vertical_button',
  _new_button: 'new_button',
  _print_button: 'print_button',
  _save_button: 'save_button',
  _c17: 'c17',
  _c25: 'c25',
  _c26: 'c26',
  _c27: 'c27',
  _c28: 'c28',
  _c29: 'c29',
  _c30: 'c30',
  _c34: 'c34',
  _c35: 'c35',
  _c36: 'c36',
  _c37: 'c37',
  _c38: 'c38',
  _c39: 'c39',
  _c1: 'c1',
  _c2: 'c2',
  _c10: 'c10',
  _c11: 'c11',
  _c13: 'c13',
  _c14: 'c14',
  _c19: 'c19',
  _c20: 'c20',
  _c6: 'c6',
  _c22: 'c22',
  _c9: 'c9',
  _c18: 'c18',
  _c23: 'c23',
  _c24: 'c24',
  _c31: 'c31',
  _c32: 'c32',
  _c33: 'c33',
  _c3: 'c3',
  _c12: 'c12',
  _c15: 'c15',
  _c21: 'c21',
}